<div class="skeleton-header">
    <div class="skeleton-header__left">
        <div class="skeleton-header__row">
            @if (showBack) {
                <div class="skeleton-header__back skeleton"></div>
            }
            <div
                class="skeleton-header__title skeleton skeleton-header__title--{{ titleWidth }}"
            ></div>
        </div>
        <div class="skeleton-header__row">
            <div
                class="skeleton-header__order-id skeleton skeleton-header__order-id--{{
                    orderIdWidth
                }}"
            ></div>
            <div class="skeleton-header__actions">
                @for (a of actions; track $index) {
                    <div class="skeleton-header__action skeleton">
                        <div class="skeleton-header__action-icon skeleton"></div>
                        <div class="skeleton-header__action-text skeleton"></div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="skeleton-header__right">
        <div
            class="skeleton-header__amount skeleton skeleton-header__amount--{{ amountWidth }}"
        ></div>
        <div class="skeleton-header__badges">
            @for (b of badges; track $index) {
                <div class="skeleton-header__badge skeleton"></div>
            }
        </div>
    </div>
</div>
